/** The public viewer is supplied by the Desk, like the compiler recipe for a
 * build. Gate approval and retry identity cover the authored publication;
 * the immutable release decision separately pins and verifies all viewer bytes.
 * No other action may discard operands when identifying its effect. */
export function authoredCanvasPublicationInput(input) {
  if (!input || typeof input !== "object" || Array.isArray(input) || (input.action !== "canvas-public-publish" && input.action !== "canvas-friend-link")) return input;
  const { hostScript, hostStyle, ...authored } = input;
  return authored;
}
